import {twJoin} from 'tailwind-merge'
import {useTranslation} from 'react-i18next'
import {useBoolean} from 'usehooks-ts'

import {IconChevronDown, IconChevronUp} from '@sdox/icons'

import {Button, LazyImage, RichText, useSlideshowContext} from '../../'
import {preventNonMouseEvent} from '../utils'

interface SlideshowSlideMobileProps {
  index: number
}

export const SlideshowSlideMobile = (props: SlideshowSlideMobileProps) => {
  const {index} = props
  const {items} = useSlideshowContext()
  const {value: isExpanded, toggle: toggleExpanded} = useBoolean()
  const {t} = useTranslation()

  const item = items[index]
  const hasText = item.richText.trim().length > 0

  return (
    <div
      className={twJoin(
        'relative size-full md:hidden',
        hasText && 'pb-spacing-96',
      )}
    >
      <LazyImage
        src={item.src}
        placeholderSrc={item.placeholderSrc}
        alt={item.alt}
        width={item.width}
        height={item.height}
        draggable={false}
        hasBackground={false}
        className={'relative size-full select-none object-contain object-center'}
      />
      {!isExpanded && hasText ? (
        <div className={'absolute inset-x-0 bottom-0 z-10 h-spacing-48 bg-gradient-to-t from-black to-transparent'} />
      ) : null}
      {hasText ? (
        <div
          className={twJoin(
            'absolute inset-0 flex flex-col',
            'transition-all duration-500',
            'bg-black text-glyph-inversed-secondary',
            'overflow-hidden',
            !isExpanded && 'translate-y-[calc(100%-96px)]',
            isExpanded && 'translate-y-0',
          )}
          // disable carousel drag for non-mouse users on scrollable text container.
          onPointerDownCapture={preventNonMouseEvent}
        >
          <div className={'flex justify-center'}>
            <Button
              variant={'overlay'}
              size={'small'}
              onClick={toggleExpanded}
              className={'w-full'}
              leading={isExpanded ? <IconChevronDown /> : <IconChevronUp />}
              aria-label={t('common:slideshow.showText')}
            />
          </div>
          <div
            className={twJoin(
              'h-full overflow-y-auto p-spacing-20',
              !isExpanded && 'hide-scrollbar',
              isExpanded && 'sdox-scrollbar-inversed',
            )}
          >
            <RichText content={item.richText} />
          </div>
        </div>
      ) : null}
    </div>
  )
}
